import styled from "styled-components";
import { Colors} from "@shared/styles/colors";
import { buttonProps } from "./type";

export const LoginButton = styled.button<buttonProps>`
  border-radius: 10px;
  width: ${(props) => `${props.width}px`}; /* props로 받은 width 적용 */
  height: ${(props) => `${props.height}px`}; /* props로 받은 height 적용 */
  background: ${Colors.loginButtonColor}; /* 기본 연한 보라색 배경색 */
  color: ${Colors.defaultContainerColor}; /* 텍스트 색상을 흰색으로 설정 */

  border: none; /* 테두리 없애기 */
  font-size: ${(props) =>
    `${props.fontSize}px`}; /* props로 받은 fontSize 적용 */
  font-weight: bold;
  cursor: pointer;
  align-self: center;

  &:hover {
    background: ${Colors.loginPurple}; /* 호버 시 배경색 뽀라색으로 변경 */
  }

  &:active {
    background: ${Colors.loginPurple}; /* 클릭 시 배경색 조금 더 진한 노란색 */
  }
`;
